import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";

@Directive({
  selector: "[vpAttentionTo]",
  standalone: false
})
export class AttentionToDirective {
  @Input() vpAttentionTo!: string;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) {}

  // @HostListener("mouseenter") onMouseEnter() {
  //   this.setAttention(this.vpAttentionTo);
  // }

  // @HostListener("mouseleave") onMouseLeave() {
  //   this.setAttention(this.vpAttentionTo);
  // }

  setAttention(attention: boolean) {
    if (attention) {
      this.renderer.addClass(this.element.nativeElement, "attention");
    } else {
      this.renderer.removeClass(this.element.nativeElement, "attention");
    }
  }
}
